import React, { useState } from 'react';
import Logo from '../assets/svg/LogoPassword.svg';
import Close from '../assets/svg/CloseButton.svg';
import ShowPassword from "../assets/svg/ShowPassword.svg";
import HidePassword from "../assets/svg/HidePassword.svg";

const ChangePassword = ({ onSubmit, submitText, onClose }) => {
    const [password, setPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };
    const toggleNewPasswordVisibility = () => {
        setShowNewPassword((prev) => !prev);
    };
    const toggleConfirmNewPasswordVisibility = () => {
        setShowConfirmNewPassword((prev) => !prev);
    };

    return (
        <div className="flex flex-col space-y-6 w-full max-w-[693px] mx-auto py-12 px-6 rounded-lg">
            <div className="absolute right-6 top-6 cursor-pointer" onClick={onClose}>
                <img className="w-[31px] h-[31px]" src={Close} alt="Close" />
            </div>
            <div className="flex justify-center items-center mx-auto">
                <img className="w-[207px] h-[222.5px]" src={Logo} alt="" />
            </div>
            <form className="space-y-6">
                <div className="flex flex-col justify-center items-center mx-auto space-y-4 w-full h-[72px]">
                    <input
                        type={showPassword ? "text" : "password"}
                        id="password"
                        className="bg-[#E8E8E8] rounded-lg w-full h-full text-center text-[24px] font-[500]"
                        placeholder="Old password"
                        required
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <button
                        type="button"
                        onClick={togglePasswordVisibility}
                        className="absolute right-28 transform -translate-y-1/3"
                    >
                        <img
                            className="w-6 h-6"
                            src={showPassword ? HidePassword : ShowPassword}
                            alt="toggle"
                        />
                    </button>
                </div>
                <div className="flex flex-col justify-center items-center mx-auto space-y-4 w-full h-[72px]">
                    <input
                        type={showNewPassword ? "text" : "password"}
                        id="new_password"
                        className="bg-[#E8E8E8] rounded-lg w-full h-full text-center text-[24px] font-[500]"
                        placeholder="New password"
                        required
                        onChange={(e) => setNewPassword(e.target.value)}
                    />
                    <button
                        type="button"
                        onClick={toggleNewPasswordVisibility}
                        className="absolute right-28 transform -translate-y-1/3"
                    >
                        <img
                            className="w-6 h-6"
                            src={showNewPassword ? HidePassword : ShowPassword}
                            alt="toggle"
                        />
                    </button>
                </div>
                <div className="flex flex-col justify-center items-center mx-auto space-y-4 w-full h-[72px]">
                    <input
                        type={showConfirmNewPassword ? "text" : "password"}
                        id="confirm_password"
                        className="bg-[#E8E8E8] rounded-lg w-full h-full text-center text-[24px] font-[500]"
                        placeholder="Confirm New password"
                        required
                        onChange={(e) => setConfirmNewPassword(e.target.value)}
                    />
                    <button
                        type="button"
                        onClick={toggleConfirmNewPasswordVisibility}
                        className="absolute right-28 transform -translate-y-1/3"
                    >
                        <img
                            className="w-6 h-6"
                            src={showConfirmNewPassword ? HidePassword : ShowPassword}
                            alt="toggle"
                        />
                    </button>
                </div>
            </form>
            <div className="flex flex-col justify-center items-center mx-auto space-y-4 w-full h-[72px]">
                <button
                    className="bg-[#134F98] h-full w-full rounded-lg text-[24px] text-white"
                    onClick={(e) => {
                        e.preventDefault();
                        onSubmit(password, newPassword, confirmNewPassword);
                    }}
                >
                    {submitText}
                </button>
            </div>
        </div>
    );
};

export default ChangePassword;